import { getFirestore, collection, addDoc, getDocs, deleteDoc, doc, query, where } from 'firebase/firestore';
import { getFirebaseApp } from './firebaseConfig';

const db = getFirestore(getFirebaseApp());
const statesCollection = collection(db, 'states');


// type: 'tool' | 'post'
export async function addStateToFirestore(name, uid, type) {
  const docRef = await addDoc(statesCollection, { name, uid, type });
  return docRef.id;
}


// type: 'tool' | 'post'
export async function getStatesFromFirestore(uid, type) {
  let q = statesCollection;
  if (uid && type) {
    q = query(statesCollection, where('uid', '==', uid), where('type', '==', type));
  } else if (uid) {
    q = query(statesCollection, where('uid', '==', uid));
  } else if (type) {
    q = query(statesCollection, where('type', '==', type));
  }
  const snap = await getDocs(q);
  return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

export async function deleteStateFromFirestore(id) {
  await deleteDoc(doc(db, 'states', id));
}
